import React from 'react'
import { connect } from 'react-redux';

import ActionButtons from '../../commons/ActionButtons'

import Selection from './Selection'
import Settings from './Settings'

import {
  loanDetailChanged,
  updateLoanDetailStart,
} from './../../../actions';

import {
  showOffsetAccount,
} from 'utils/businessRequirements'

class LoanSetup extends React.Component {
  state = {
    continueButtonEnabled: true
  }

  componentDidMount() {
    window.scrollTo({top: 0})
  }

  onChange = (data) => {
    this.props.loanDetailChanged(data)
  }

  onContinueClick = () => {
    this.setState({ continueButtonEnabled: false })
    this.props.updateLoanDetailStart()
  }

  render() {
    const {
      interestType,
      loanApplication
    } = this.props

    const { loanAmount } = loanApplication

    const { continueButtonEnabled } = this.state

    return(
      <div>
        <h3 className='mb-3'>Set up your loan</h3>

        <Selection
          interestType={ interestType }
          loanAmount={ loanAmount }
          onChange={ this.onChange }
        />
        <Settings
          onChange={ (data) => this.onChange({setting: data})}
          showOffsetAccount={ showOffsetAccount(interestType) }
        />
        <ActionButtons
          continueEnabled={ continueButtonEnabled }
          onContinueClick={ this.onContinueClick }
          onGoBackClick={ this.props.onGoBackClick }
        />

      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  interestType: state.loanDetail.interestType,
  loanApplication: state.loanApplication,
})

export default connect(mapStateToProps, {
  loanDetailChanged,
  updateLoanDetailStart,
})(LoanSetup)
